import { IWarehouseContactInfo } from "types/warehouses";

const formatAddress = (contact: IWarehouseContactInfo) => {
    return `${contact?.streetAddress}${contact?.streetAddress2 ? `, ${contact.streetAddress2}` : ""}, ${contact.city}, ${contact.zipCode}`
}

export default formatAddress;